/* jslint browser: true */
/* global window */
import React, { Component } from 'react';
import axios from 'axios';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
import { apiUrl } from '../lib/constants';
import Login from './Login';
import ProfessionnelsList from './ProfessionnelsList';
import FormProgramme from './FormProgramme';
import MenusList from './MenusList';
import Annexes from './Annexes';
import FormProfessionnel from './FormProfessionnel';
import Commande from './Commande';
import ResetPassword from './ResetPassword';
import NotFound from './NotFound';
import CommandeFin from './commande/CommandeFin';

class Wrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAdmin : false,
        };
    }
    componentWillMount() {
        axios.get(`${apiUrl}/api/v1/isAdmin`)
            .then((response) => {
                this.setState({ isAdmin: response.data });
            });
    }

    render() {
        return (
            <div className="wrapper">
                <BrowserRouter>
                    <div className="router">
                        <Switch>
                            <Route exact path="/login" component={Login} />
                            <Route exact path="/admin/login" render={props => (<Login {...props} admin />)} />
                            <Route exact path="/admin/pro" component={ProfessionnelsList} admin />
                            <Route exact path="/admin/menus" component={MenusList} admin />
                            <Route exact path="/programme" component={FormProgramme} />
                            <Route exact path="/moncompte" component={FormProfessionnel} />
                            <Route exact path="/login/reset/:hash" component={ResetPassword} />
                            <Route exact path="/admin/annexes" component={Annexes} admin />
                            <Route exact path="/commande" component={Commande} />
                            <Route exact path="/commande/:type" component={CommandeFin} />
                            {
                                window.localStorage.getItem('token') === undefined || window.localStorage.getItem('token') === '' ? <Redirect from="/" to="/login" />
                                    : this.state.isAdmin !== 0 ? <Redirect from="/" to="/admin/pro" />
                                        : <Redirect from="/" to="/programme" />
                            }
                            {
                                window.localStorage.getItem('token') !== undefined && window.localStorage.getItem('token') !== '' ? <Redirect from="/login" to="/programme" />
                                    : this.state.isAdmin !== 0 ? <Redirect from="/admin/login" to="/admin/pro" />
                                        : <Redirect from="/login" to="/programme" />
                            }
                            <Route component={NotFound} />
                        </Switch>
                    </div>
                </BrowserRouter>
            </div>
        );
    }
}

export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/Wrapper.js